import React from 'react';

const MarketingMaterialSampleWatermark = () => {
  return (
    <span className="marketing-material-sample-watermark" aria-hidden="true">
      Sample
    </span>
  );
};

export default MarketingMaterialSampleWatermark;
